import React, { Component } from 'react';
import { inject, observer } from "mobx-react/index";
import PopupOpenImage from '../../../assets/images/popup-open-dark.png';

@inject("store")
@observer
export default class PopupOpenDarkIcone extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <img src={PopupOpenImage} alt="popup-open-dark" className={`popup-open-dark-icone ${this.props.className || ""}`} />;
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/PopupOpenDarkIcone.js